import useAppContext from 'flow/hooks/useAppContext';
import { TranscriptionExtendedResultCode } from 'flow/types/CallRecord';
import { CallRecordKey } from 'flow/types/EntityKeys';
import CardCallDetailsContainer from 'flow/components/pbx/v2/misc/CardCallDetailsContainer';
import SectionTitle from 'flow/components/pbx/v2/detail-page/SectionTitle';
import SectionTranscriptionError from './SectionTranscriptionError';

interface Props {
    resultCode: TranscriptionExtendedResultCode;
    callRecordKey: CallRecordKey;
}

const CardTranscriptionError = ({ resultCode, callRecordKey }: Props) => {
    const { i18next } = useAppContext();

    return (
        <CardCallDetailsContainer className="flex-col gap-3">
            <div className="flex flex-col">
                <SectionTitle title={i18next.t('ai.summary.summary')} />
                <SectionTranscriptionError
                    resultCode={resultCode}
                    callRecordKey={callRecordKey}
                />
            </div>
        </CardCallDetailsContainer>
    );
};

export default CardTranscriptionError;
